import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../utils/translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    // Intentar leer del localStorage, por defecto 'es'
    const [language, setLanguage] = useState(() => {
        return localStorage.getItem('app_lang') || 'es';
    });

    const switchLanguage = (lang) => {
        setLanguage(lang);
        localStorage.setItem('app_lang', lang);
    };

    // Función 't' para obtener la traducción anidada (ej: t('profile.title'))
    const t = (path) => {
        const keys = path.split('.');
        let current = translations[language];

        for (let key of keys) {
            if (current[key] === undefined) {
                console.warn(`Translation missing for key: ${path} in language: ${language}`);
                return path; // Fallback to key if not found
            }
            current = current[key];
        }
        return current;
    };

    return (
        <LanguageContext.Provider value={{ language, switchLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
